import React, { useEffect } from "react";
import { TextField, Grid, Box, IconButton, Alert } from "@mui/material";
import { useLoading } from "../../common/LoadingContext";
import { useNotificationContext } from "../../common/NotificationContext";
import { getCaptchCodeImg } from "../../services/captchservice";
import ReplayIcon from "@mui/icons-material/Replay";
const CaptchCaptur = ({
  setresObj,
  resObj,
  setCaptchImg,
  captchImg,
  onReloadCaptch,
  applicationId,
  setAttemptsExhausted,
  attemptsExhausted,
}) => {
  const { showNotification } = useNotificationContext();

  const { setLoading } = useLoading();
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const getCapImage = async () => {
    let requestObj = {
      applicationId: applicationId,
    };
    try {
      setAttemptsExhausted(false);
      setLoading(true);
      const captchTextResponse = await getCaptchCodeImg(baseUrl, requestObj);
      if (captchTextResponse?.messageCode === 6) {
        setCaptchImg(captchTextResponse?.text);
        setresObj({ ...resObj, fileName: captchTextResponse?.fileName });
      } else if (captchTextResponse.messageCode === 2) {
        setAttemptsExhausted(true);
        setCaptchImg("");
        setresObj({
          captcha_txt: "",

          fileName: "",
        });
        showNotification(
          "Error",
          captchTextResponse?.message ?? "Failed To Reload Captcha"
        );
      } else {
        showNotification(
          "Error",
          captchTextResponse?.message ?? "Failed to load"
        );
      }
    } catch (err) {
      showNotification("Error", err?.message ?? "Failed to load");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    getCapImage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <>
      <Grid container className="bg-white ">
        <Grid item xs={12} md={12}>
          <Grid item xs={12} md={12} sx={{ p: 2, m: 2 }} className="captchaDiv">
            <Box>
              {" "}
              <Grid
                container
                spacing={2}
                direction="row"
                justifyContent="center"
                alignItems="center"
              >
                <Grid
                  item
                  xs={12}
                  sm={12}
                  display="flex"
                  justifyContent="center"
                >
                  {!attemptsExhausted && (
                    <img
                      style={{ width: "150px", height: "40px" }}
                      src={"data:image/png;base64," + captchImg}
                      alt={"Captcha"}
                      loading="lazy"
                    />
                  )}
                  {attemptsExhausted && (
                    <Alert severity="error" mt={1}>
                      You have exceeded the maximum number of attempts for
                      captcha generation, Please try again after sometime.
                    </Alert>
                  )}
                  <IconButton
                    type="IconButton"
                    size="small"
                    variant="contained"
                    sx={{ ml: 2 }}
                    onClick={
                      resObj?.fileName?.length ? onReloadCaptch : getCapImage
                    }
                  >
                    <ReplayIcon />
                  </IconButton>
                </Grid>
                {!attemptsExhausted && (
                  <TextField
                    sx={{ my: 1, float: "left" }}
                    value={resObj?.captcha_txt}
                    margin="normal"
                    size="small"
                    className="signinText"
                    required
                    // fullWidth
                    label="Captcha"
                    name="captcha_txt"
                    autoComplete="off"
                    onChange={(e) => {
                      setresObj({ ...resObj, captcha_txt: e.target.value });
                    }}
                  />
                )}
              </Grid>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default CaptchCaptur;
